import _asyncToGenerator from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import { PURCHASE_CACHE_TAGS, GAME_CACHE_TAGS } from '../tags';
import { Endpoints, ServerResponseKeys } from '../../../api/Constants';
import { postRewardCenterAdapter, postRewardCenterHistoryAdapter, postRewardOfferHistoryDetailsAdapter, postOfferDetailAdapter } from './adapters';
import { getAssetsPackage } from '../assetsPackage';
import { validateJson } from '../../../utils/jsonschema/validator';
import HTTP from '../../../utils/httpMethods';
import { getTimeout } from '../../api/services/utils/config';
export var postRewardCenterMutation = {
  query: function query() {
    return {
      url: Endpoints.INIT_REWARDS,
      body: {
        timeout: getTimeout(Endpoints.INIT_REWARDS, HTTP.POST),
        cache: {
          maxAge: 1000
        }
      }
    };
  },
  providesTags: ['RewardCenter'],
  keepUnusedDataFor: 0,
  transformResponse: function () {
    var _transformResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(response) {
      var rewardCenterResponse;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            rewardCenterResponse = response[ServerResponseKeys.CALL_RESPONSE];
            if (!validateJson(Endpoints.INIT_REWARDS, rewardCenterResponse)) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", postRewardCenterAdapter(rewardCenterResponse));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function transformResponse(_x) {
      return _transformResponse.apply(this, arguments);
    }
    return transformResponse;
  }(),
  onQueryStarted: function () {
    var _onQueryStarted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref, _ref2) {
      var _ref$requestAssetsDat, requestAssetsData, dispatch, queryFulfilled, _yield$queryFulfilled, data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _ref$requestAssetsDat = _ref.requestAssetsData, requestAssetsData = _ref$requestAssetsDat === void 0 ? null : _ref$requestAssetsDat;
            dispatch = _ref2.dispatch, queryFulfilled = _ref2.queryFulfilled;
            _context2.next = 4;
            return queryFulfilled;
          case 4:
            _yield$queryFulfilled = _context2.sent;
            data = _yield$queryFulfilled.data;
            if (!(requestAssetsData && data !== null && data !== void 0 && data.assetsPackageId)) {
              _context2.next = 9;
              break;
            }
            _context2.next = 9;
            return dispatch(getAssetsPackage.initiate({
              assetsPackageId: data === null || data === void 0 ? void 0 : data.assetsPackageId
            }));
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function onQueryStarted(_x2, _x3) {
      return _onQueryStarted.apply(this, arguments);
    }
    return onQueryStarted;
  }()
};
export var postOfferDetailMutation = {
  query: function query(data) {
    return {
      url: "".concat(Endpoints.GET_REWARD_DETAIL).concat(data.offerId),
      method: 'post'
    };
  },
  invalidatesTags: [{
    type: PURCHASE_CACHE_TAGS.REFRESH_CONSUMABLES
  }],
  transformResponse: function () {
    var _transformResponse2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(response, meta, arg) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", postOfferDetailAdapter(response[ServerResponseKeys.CALL_RESPONSE], arg.rewardCenterBaseUrl));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function transformResponse(_x4, _x5, _x6) {
      return _transformResponse2.apply(this, arguments);
    }
    return transformResponse;
  }()
};
export var postPurchaseOfferMutation = {
  query: function query(data) {
    return {
      url: Endpoints.PURCHASE_OFFER,
      method: 'post',
      body: {
        data: data
      }
    };
  },
  invalidatesTags: [{
    type: PURCHASE_CACHE_TAGS.REFRESH_CONSUMABLES
  }, {
    type: GAME_CACHE_TAGS.GET_GAME_ROOMS
  }],
  transformResponse: function () {
    var _transformResponse3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(response) {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", response);
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    function transformResponse(_x7) {
      return _transformResponse3.apply(this, arguments);
    }
    return transformResponse;
  }()
};
export var postRewardCenterHistoryMutation = {
  query: function query() {
    return {
      url: Endpoints.GET_OFFER_HISTORY
    };
  },
  providesTags: ['RewardCenter'],
  transformResponse: function () {
    var _transformResponse4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(response, meta, arg) {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", postRewardCenterHistoryAdapter(response[ServerResponseKeys.CALL_RESPONSE], arg.rewardCenterBaseUrl));
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    function transformResponse(_x8, _x9, _x10) {
      return _transformResponse4.apply(this, arguments);
    }
    return transformResponse;
  }()
};
export var postRewardOfferHistoryDetailsMutation = {
  query: function query(data) {
    return {
      url: "".concat(Endpoints.GET_PLAYER_OFFER_DETAILS).concat(data.activeHistoryItemId),
      method: 'post'
    };
  },
  providesTags: ['RewardCenter'],
  transformResponse: function () {
    var _transformResponse5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(response) {
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", postRewardOfferHistoryDetailsAdapter(response[ServerResponseKeys.CALL_RESPONSE]));
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    function transformResponse(_x11) {
      return _transformResponse5.apply(this, arguments);
    }
    return transformResponse;
  }()
};
export var postRewardOfferHistorySendEmailMutation = {
  query: function query(data) {
    return {
      url: Endpoints.SEND_OFFER_EMAIL,
      method: 'post',
      body: {
        data: {
          rpid: data.activeHistoryItemId
        }
      }
    };
  },
  providesTags: ['RewardCenter']
};
export var postRewardCenterDisplayedMutation = {
  query: function query() {
    return {
      url: Endpoints.REWARD_CENTER_DISPLAYED,
      method: 'post'
    };
  },
  providesTags: ['RewardCenter']
};